module.exports = __webpack_public_path__ + "static/media/mis_dashboard_active.19192a89.svg";